<script setup>
import { watch } from "vue";
// Create a watch of window.matchMedia
watch(
  () => window.matchMedia("(prefers-color-scheme: dark)").matches,
  (isDark) => {
    if (isDark) {
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", "/DarkLogo.svg");
    } else {
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", "/Logo.svg");
    }
  }
);
</script>

<template>
  <RouterView />
  <p class="my-6 text-center text-sm text-secondary dark:text-night-muted">
    Powered by Adam-lytics
  </p>
</template>
